import keyWords from './keyWords'
export default keyWords
